import { Table } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { useEffect } from 'react';

const CONDENSED_FONT_HREF = 'https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@400;700&display=swap';

// Loaded here (not in index.html) so the ~90KB Latin-subset font cost is only paid by
// visitors who actually render a table, not every page on the site. Guarded against
// multiple OGTable instances on the same page all trying to inject it, and against a
// second mount (e.g. React StrictMode's double-invoke) re-adding it.
const ensureCondensedFontLoaded = () => {
    if (document.querySelector(`link[href="${CONDENSED_FONT_HREF}"]`)) {
        return;
    }
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = CONDENSED_FONT_HREF;
    document.head.appendChild(link);
};

const getStyles = (theme) => ({
    '& thead th': {
        fontWeight: '600 !important',
    },
    '& tbody td': {
        borderBottom: '0 !important',
    },
    '& tbody tr:nth-of-type(odd)': {
        backgroundColor: 'grey.200',
    },
    // Set on & td, & th directly -- MuiTableCell-root sets its own font-family, so a
    // font-family on the ancestor <table> doesn't cascade down to it.
    '& td, & th': {
        fontFamily: `"Roboto Condensed", ${theme.typography.fontFamily}`
    },
});

const OGTable = ({
    children,
    sx,
    ...props
}) => {
    const theme = useTheme();

    useEffect(() => {
        ensureCondensedFontLoaded();
    }, []);

    const mergedStyles = {
        ...getStyles(theme),
        ...sx
    };

    return (
        <Table size="small" sx={mergedStyles} {...props}>
            {children}
        </Table>
    );
};

export default OGTable;
